import { Helmet } from 'react-helmet-async';

type SeoHeadProps = {
  title: string;
  description: string;
  /**
   * Path portion of the URL, e.g. "/services".
   * Used to build the canonical/og:url when `canonical` is not provided.
   */
  path?: string;
  /**
   * Optional explicit canonical URL. If not provided, one is built from `path`.
   */
  canonical?: string;
  /**
   * Open Graph type. Defaults to "website".
   */
  ogType?: string;
};

const SITE_URL = 'https://vernoweb.com';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

export function SeoHead({ title, description, path, canonical, ogType = 'website' }: SeoHeadProps) {
  const url = canonical ?? (path ? `${SITE_URL}${path}` : SITE_URL);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      <link rel="canonical" href={url} />

      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={DEFAULT_OG_IMAGE} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
    </Helmet>
  );
}

